<template>
    <Row type="none" class="bg-white rounded shadow">

        <div class="grid grid-cols-12 gap-3 py-5 container">
            <div class="col-span-12 md:col-span-4 relative pl-0">
                <div class="font-bold text-sm bg-white px-1 text-gray-500 z-30 absolute bottom-9 ml-2">
                    {{ $t('service.serviceName') }}<span class="text-red-500 text-xl">*</span>
                </div>
                <b-form-input v-model="modelForm.name" class="border-gray-300 h-11 focus:ring-0" @keyup.enter="isNoErrorAddService"/>
            </div>

            <div class="col-span-12 md:col-span-4 relative pl-0">
                <div class="font-bold text-sm bg-white px-1 text-gray-500 z-30 absolute bottom-9 ml-2">
                    {{ $t('service.price') }}<span class="text-red-500 text-xl">*</span>
                </div>
                <b-form-input v-model="modelForm.price" type="number" class="border-gray-300 h-11 focus:ring-0" @keyup.enter="isNoErrorAddService"/>
            </div>

            <div class="col-span-12 md:col-span-2 relative pl-0">
                <div class="font-bold text-sm bg-white px-1 text-gray-500 z-30 absolute bottom-9 ml-2">
                    {{ $t('currency') }}<span class="text-red-500 text-xl">*</span>
                </div>

                <b-form-select
                    v-model="modelForm.currency"
                    :options="getCurrencies"
                    value-field="id"
                    text-field="shortName"
                    class="border-gray-300 h-11 focus:ring-0"
                >
                </b-form-select>
            </div>

            <div v-if="!isEditPage" class="col-span-12 md:col-span-2">
                <b-button
                    :disabled="addDisabled()"
                    class="btn bg-main h-11 w-full font-bold"
                    @click="addService()"
                >
                    {{ $t('add') }}
                </b-button>
            </div>

        </div>

        <div v-if="services.length > 0" class="d-sm-flex">
            <table class="w-full">
                <thead>
                <tr class="bg-lightGray h-11 font-bold">
                    <th class="d-none d-md-table-cell pl-3">#</th>
                    <th>{{ $t('service.serviceName') }}</th>
                    <th>{{ $t('service.price') }}</th>
                    <th>{{ $t('actions') }}</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(service, index) in services"
                    :key="index"
                    class="h-11"
                >
                    <td class="py-2 d-none d-md-table-cell pl-3">{{ index + 1 }}</td>
                    <td class="py-2">{{ service.name }}</td>
                    <td class="py-2">{{ showCurrencyById(service.currency, service.price) }}</td>
                    <td class="py-2 d-table-cell">
                        <img src="/images/Union.png" @click="deleteRowTable(index)" alt="" class="h-7 cursor-pointer">
                    </td>
                </tr>
                </tbody>
            </table>
        </div>


        <div class="container py-5" v-if="services.length > 0">
            <b-button
                class="btn bg-main h-11 font-bold"
                @click="addServices()"
            >
                <span v-show="isLoading" class="spinner-border spinner-border-sm" role="status"
                      aria-hidden="true"></span>
                <span>{{ $t('save') }}</span>
            </b-button>
        </div>
        <div class="container py-5" v-if="isEditPage && !isEditService">
            <b-button
                class="btn bg-main h-11 font-bold"
                @click="serviceEdit()"
            >
                <span v-show="isLoading" class="spinner-border spinner-border-sm" role="status"
                      aria-hidden="true"></span>
                <span>{{ $t('edit') }}</span>
            </b-button>
        </div>
    </Row>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import currencyFormat from "@/mixin/currencyFormatMixin";
import accessMixin from "@/mixin/accessMixin";
import dateFormatting from "@/mixin/dateFormattingMixin";
import Row from "@/components/html/Row.vue";

export default {
    name: "Add",
    mixins: [currencyFormat, accessMixin, dateFormatting],
    components: {Row},
    data() {
        return {
            isEditService: true,
            isEditPage: false,
            isLoading: false,
            services: [],
            modelForm: {
                id: null,
                name: '',
                price: '',
                currency: ''
            },
            search: {
                page: 1,
            },
            breadcrumbItems: [
                {name: 'home', url: ''},
                {name: 'service.title', url: 'services'},
                {name: 'service.addService'},
            ],
        }
    },
    computed: {
        ...mapGetters(['getCurrencies', 'getService', 'getUserCompany']),
    },
    methods: {
        ...mapActions(['fetchCurrencies', 'pushServices', 'fetchService', 'changeService', 'setBreadcrumbItems']),
        deleteRowTable(index) {
            this.services.splice(index, 1)
        },
        isNoErrorAddService() {
            if (!this.addDisabled() && !this.isEditPage) {
                this.addService()
            }
        },
        addService() {
            let newModelForm = {name: '', price: '', currency: this.modelForm.currency}
            this.services.push(this.modelForm)
            this.modelForm = newModelForm
        },
        addServices() {
            this.isLoading = true
            let services = []

            for (let service of this.services) {
                services.push({
                    'name': service.name,
                    'price': service.price,
                    'currency': '/api/currencies/' + service.currency
                })
            }

            this.pushServices({serviceDtos: services})
                .then((response) => {
                    this.$i18nHelper.flash(response.length + " " + this.$t('service.addedServices'), 'success')
                    this.isLoading = false
                    this.$i18nHelper.toUrl('services')
                })
        },
        isChangedService() {
            if (this.$route.name === 'services/edit') {
                this.isEditService = (this.modelForm.name === this.getService.name &&
                    this.modelForm.price === this.showCurrencyById(0, this.getService.price) &&
                    this.modelForm.currency === this.getService.currency.id);
            }
        },
        serviceEdit() {
            this.$root.showOverlay = true
            this.changeService(this.modelForm)
                .then(() => {
                    this.$i18nHelper.flash("Muvaffaqiyatli o'zgartirildi", 'success')
                    this.$root.showOverlay = false
                    this.$i18nHelper.toUrl('services')
                })
                .catch(() => {
                    this.$i18nHelper.flash(this.$t('unknownError'), 'warning')
                    this.$root.showOverlay = false
                })
        },
        addDisabled() {
            return this.modelForm.name === '' || this.modelForm.price === '' || this.modelForm.currency === '';
        }
    },
    watch: {
        'modelForm.name'() {
            this.isChangedService()
        },
        'modelForm.price'() {
            this.isChangedService()
        },
        'modelForm.currency'() {
            this.isChangedService()
        }
    },
    created() {
        this.setBreadcrumbItems(this.breadcrumbItems)
    },
    mounted() {
        this.fetchCurrencies()
        if (this.$route.name === 'services/edit') {
            this.$root.showOverlay = true
            this.isEditPage = true

            this.fetchService(this.$route.params.id)
                .then(() => {
                    this.modelForm.id = this.getService.id
                    this.modelForm.name = this.getService.name
                    this.modelForm.price = this.showCurrencyById(0, this.getService.price)
                    this.modelForm.currency = this.getService.currency.id
                })
                .finally(() => {
                    this.$root.showOverlay = false
                })
        } else {
            this.modelForm.currency = this.getUserCompany.baseCurrency.id
        }
    }
}
</script>

<style scoped>

</style>